export enum QuestionnaireName {
  Citizenship = "citizenship",
  Family = "family",
  Redditi = "redditi",
  Patrimonio = "patrimonio",
}
